import { CountryCode, DEFAULT_COUNTRY_CODE } from "./language";

interface ICountryConfig {
  dixaMessengerToken?: string;
  appleStoreUrl: string;
  androidStoreUrl: string;
}

export const countryConfig: Record<string, ICountryConfig> = {
  [CountryCode.Danish]: {
    dixaMessengerToken: "dc4f1ab9cb274adb9bafb4c0c450944c",
    appleStoreUrl: "https://apps.apple.com/dk/app/nordisk-film/id1620553745",
    androidStoreUrl:
      "https://play.google.com/store/apps/details?id=com.nordiskfilmplus.android",
  },
  [CountryCode.Finnish]: {
    dixaMessengerToken: "7e8473f2abcf4c5c9a1c77da4de8fcef",
    appleStoreUrl: "https://apps.apple.com/fi/app/nordisk-film/id1620553745",
    androidStoreUrl:
      "https://play.google.com/store/apps/details?id=com.nordiskfilmplusfi.android",
  },
};

export const getCountryConfig = (country: string) => {
  const countryCode = country.toUpperCase();
  return countryConfig[countryCode] || countryConfig[DEFAULT_COUNTRY_CODE];
};
